import { type Surface } from '../../common/types';

export const dataIsSurface = (data: any): data is Surface =>
	data?.type && data?.key && data?.fields;
